import cn from 'classnames';
import React from 'react';

import {selectContextRawData} from 'modules/context/context-selector';
import {useAppSelector} from 'store/config/hooks';

import {AisAvailabilityStatusDashboard} from './dashboards/ais-availability-status-dashboard';
import {AisOperationsProtocolDashboard} from './dashboards/ais-operations-protocol-dashboard';
import {AisRegisterDashboard} from './dashboards/ais-register-dashboard';
import {AisRequestStatisticsDashboard} from './dashboards/ais-request-statistics-dashboard';
import {AisRequestStatusesDashboard} from './dashboards/ais-request-statuses-dashboard';
import {AisTokenStatusDashboard} from './dashboards/ais-token-status-dashboard';
import {AisUnavailabilityChartDashboard} from './dashboards/ais-unavailability-chart-dashboard';

import './ais-main-page.less';

export const AisMainPage = (
) => {
    const context = useAppSelector(selectContextRawData);

    return (
        <div className={cn('ais-main-page')}>
            <AisRegisterDashboard
                context={context}
                className={cn('ais-main-page__register')}
            />

            <AisRequestStatusesDashboard
                context={context}
                className={cn('ais-main-page__request-statuses')}
            />

            <AisRequestStatisticsDashboard
                context={context}
                className={cn('ais-main-page__request-statistics')}
            />

            <AisOperationsProtocolDashboard
                context={context}
                className={cn('ais-main-page__operations')}
            />

            <AisAvailabilityStatusDashboard
                context={context}
                className={cn('ais-main-page__availability-status')}
            />

            <AisTokenStatusDashboard
                context={context}
                className={cn('ais-main-page__token-status')}
            />

            <AisUnavailabilityChartDashboard
                context={context}
                className={cn('ais-main-page__unavailability-status')}
            />
        </div>
    );
};
